import { render, staticRenderFns } from "./store_class_product.vue?vue&type=template&id=cbd97032&scoped=true&"
import script from "./store_class_product.vue?vue&type=script&lang=js&"
export * from "./store_class_product.vue?vue&type=script&lang=js&"
import style0 from "./store_class_product.vue?vue&type=style&index=0&id=cbd97032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd97032",
  null
  
)

export default component.exports